import * as tslib_1 from "tslib";
import { createSelector } from '@ngrx/store';
import { SearchActionTypes } from 'store/actions/search.actions';
var initialState = {
    quickScan: null,
    screening: {},
    searchResult: null,
    searchValidity: null,
    err: null,
    loading: []
};
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        // Get screening
        case SearchActionTypes.POST_SCREENING:
        case SearchActionTypes.GET_SCREENING: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case SearchActionTypes.POST_SCREENING_FAILED:
        case SearchActionTypes.POST_SCREENING_SUCCESS: {
            return tslib_1.__assign({}, state, { loading: clearLoading(state, SearchActionTypes.POST_SCREENING) });
        }
        case SearchActionTypes.GET_SCREENING_SUCCESS: {
            var newScreening_1 = {};
            Object.keys(action.payload).map(function (key) {
                if (action.payload[key]) {
                    newScreening_1[key] = action.payload[key];
                }
            });
            return tslib_1.__assign({}, state, { screening: tslib_1.__assign({}, state.screening, newScreening_1), loading: clearLoading(state, SearchActionTypes.GET_SCREENING) });
        }
        case SearchActionTypes.GET_SCREENING_FAILED: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, SearchActionTypes.GET_SCREENING) });
        }
        // Get specific screening
        case SearchActionTypes.GET_SPECIFIC_SCREENING: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case SearchActionTypes.GET_SPECIFIC_SCREENING_FAILED: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, SearchActionTypes.GET_SPECIFIC_SCREENING) });
        }
        case SearchActionTypes.GET_SPECIFIC_SCREENING_SUCCESS: {
            return tslib_1.__assign({}, state, { screening: tslib_1.__assign({}, state.screening, action.payload), loading: clearLoading(state, SearchActionTypes.GET_SPECIFIC_SCREENING) });
        }
        // Patch search result
        case SearchActionTypes.PATCH_SEARCH_RESULT: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case SearchActionTypes.PATCH_SEARCH_RESULT_SUCCESS: {
            return tslib_1.__assign({}, state, { searchResult: action.payload, loading: clearLoading(state, SearchActionTypes.PATCH_SEARCH_RESULT) });
        }
        case SearchActionTypes.PATCH_SEARCH_RESULT_FAILED: {
            return tslib_1.__assign({}, state, { err: action.payload, loading: clearLoading(state, SearchActionTypes.PATCH_SEARCH_RESULT) });
        }
        case SearchActionTypes.GET_SEARCH_VALIDITY: {
            return tslib_1.__assign({}, state, { loading: state.loading.concat([action.type]) });
        }
        case SearchActionTypes.GET_SEARCH_VALIDITY_SUCCESS: {
            return tslib_1.__assign({}, state, { searchValidity: action.payload, loading: clearLoading(state, SearchActionTypes.GET_SEARCH_VALIDITY) });
        }
        case SearchActionTypes.GET_SEARCH_VALIDITY_FAILURE: {
            return tslib_1.__assign({}, state, { searchValidity: null, err: action.payload, loading: clearLoading(state, SearchActionTypes.GET_SEARCH_VALIDITY) });
        }
        default: {
            return state;
        }
    }
}
var searches = function (state) { return state.search; };
var ɵ0 = searches;
var ɵ1 = function (state) { return state.err; }, ɵ2 = function (state) { return state.screening; }, ɵ3 = function (forEngines) { return createSelector(searches, function (state) {
    var isSeachDone = true;
    Object.keys(state.screening)
        .forEach(function (engine) {
        if (forEngines
            .map(function (searchEngine) { return searchEngine.toString(); })
            .indexOf(engine) >= 0 &&
            state.screening[engine] &&
            state.screening[engine].results.length > 0) {
            isSeachDone = isSeachDone && state.screening[engine].results[0].isSearchFinished;
        }
    });
    return isSeachDone;
}); }, ɵ4 = function (state) { return state.searchResult; }, ɵ5 = function (state) { return state.searchValidity; }, ɵ6 = function (state) { return state.loading; };
export var Selectors = {
    err: createSelector(searches, ɵ1),
    screening: createSelector(searches, ɵ2),
    isCurrentScreeningDone: ɵ3,
    searchResult: createSelector(searches, ɵ4),
    searchValidity: createSelector(searches, ɵ5),
    getLoading: createSelector(searches, ɵ6)
};
function clearLoading(authState, action) {
    return authState.loading.filter(function (loadingMarker) { return loadingMarker !== action; });
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6 };
